const EXTERNAL = /^([a-z][a-z\d+.-]*:|\/\/|#)/i;

export const isExternalHref = (href: string) => EXTERNAL.test(href);

/** Prefix a canonical path ('/mentions') with a tree base ('' or '/test'). */
export function withBase(basePath: string, href: string): string {
  if (!basePath || EXTERNAL.test(href)) return href;
  if (href === '/') return basePath;
  return `${basePath}${href.startsWith('/') ? '' : '/'}${href}`;
}
